export function renderStatsTemplate(data, {html}) {
  let count = '';

  if(data.hasManyResults) {
    count += `${data.nbHits} results`
  } else if (data.hasOneResult) {
    count += `1 result`
  } else {
    count += `no results`
  }

  return html `<span>${count}</span>`
}